import { isCompanyFeatureEnabled } from "../utils/companyFeatures";
import { canAccessVehicleAssignment } from "../utils/vehicleAssignmentAccess";

export const articles = [
  {
    "slug": "use-fleet-dashboard",
    "title": "Use the fleet dashboard",
    "category": "Getting started",
    "summary": "Open fleet tools and check recent alerts from one starting screen.",
    "feature": "web_dashboard",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-an-asset",
      "review-notifications",
      "use-site-board"
    ],
    "keywords": [
      "overview",
      "shortcuts",
      "summary"
    ],
    "routes": [
      "/dashboard/fleet"
    ]
  },
  {
    "slug": "use-site-board",
    "title": "Find a site on the Site Board",
    "category": "Sites & operations",
    "summary": "Locate a site card and understand the assets shown there.",
    "feature": "web_site_board",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-a-site",
      "create-geofence",
      "find-an-asset"
    ],
    "keywords": [
      "geofence",
      "search",
      "empty",
      "location"
    ],
    "routes": [
      "/dashboard/asset-board"
    ]
  },
  {
    "slug": "review-inputs",
    "title": "Review a vehicle’s input history",
    "category": "Fleet & assets",
    "summary": "Choose a device, dates and input, then read its recorded states.",
    "feature": "inputs",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "review-timeline",
      "use-vehicle-hub"
    ],
    "keywords": [
      "DIN",
      "PTO",
      "signal",
      "active",
      "inactive",
      "timeline"
    ],
    "routes": [
      "/dashboard/inputs"
    ]
  },
  {
    "slug": "create-form-template",
    "title": "Create a simple form template",
    "category": "Forms",
    "summary": "Add questions, check settings and preview a form before saving.",
    "feature": "forms",
    "permissions": [
      "forms_add"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "complete-a-form",
      "find-completed-form"
    ],
    "keywords": [
      "builder",
      "admin",
      "required",
      "preview",
      "questions"
    ],
    "routes": [
      "/dashboard/forms/admin",
      "/dashboard/forms/buildform"
    ]
  },
  {
    "slug": "find-completed-form",
    "title": "Find and read a completed form",
    "category": "Forms",
    "summary": "Search submission history, filter results and reopen saved answers.",
    "feature": "forms",
    "permissions": [
      "forms_view"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "complete-a-form",
      "save-a-form-draft"
    ],
    "keywords": [
      "submitted",
      "approved",
      "history",
      "filters"
    ],
    "routes": [
      "/dashboard/forms/completed"
    ]
  },
  {
    "slug": "use-vehicle-hub",
    "title": "Open and leave the Vehicle Hub",
    "category": "Fleet & assets",
    "summary": "Open a vehicle’s dashboard, switch sections and return to the fleet.",
    "feature": "web_asset_map",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-an-asset",
      "review-a-trip",
      "review-timeline",
      "review-inputs"
    ],
    "keywords": [
      "dashboard",
      "hub",
      "back",
      "vehicle"
    ],
    "routes": [
      "/dashboard/assets/device"
    ]
  },
  {
    "slug": "create-geofence",
    "title": "Create a geofence or site",
    "category": "Sites & operations",
    "summary": "Find a location, draw a boundary and check the saved site.",
    "feature": "web_sites",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-a-site",
      "review-automations"
    ],
    "keywords": [
      "area",
      "rectangle",
      "polygon",
      "safe zone"
    ],
    "routes": []
  },
  {
    "slug": "record-maintenance",
    "title": "Record completed maintenance",
    "category": "Maintenance",
    "summary": "Record the completion date, vehicle readings and expenses for a task.",
    "feature": "vehicle_task_management",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "review-maintenance",
      "create-maintenance-task"
    ],
    "keywords": [
      "service",
      "odometer",
      "hours",
      "expense"
    ],
    "routes": [
      "/dashboard/vehicle-dashboard",
      "/dashboard/vehicle-maintenance"
    ]
  },
  {
    "slug": "review-automations",
    "title": "Review an automation and its settings",
    "category": "Sites & operations",
    "summary": "Understand conditions, actions, vehicle selection and the rule’s status.",
    "feature": "automation",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "review-notifications",
      "create-geofence"
    ],
    "keywords": [
      "rules",
      "alerts",
      "trigger",
      "timezone",
      "enabled"
    ],
    "routes": [
      "/dashboard/automations",
      "/dashboard/createAutomations"
    ]
  },
  {
    "slug": "review-notifications",
    "title": "Find and filter notifications",
    "category": "Sites & operations",
    "summary": "Find vehicle alerts by type and date, and check Inbox or Resolved.",
    "feature": "web_notifications",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "review-timeline",
      "review-driver-safety",
      "review-automations"
    ],
    "keywords": [
      "alerts",
      "inbox",
      "resolved",
      "automation"
    ],
    "routes": [
      "/dashboard/notifications"
    ]
  },
  {
    "slug": "review-driver-safety",
    "title": "Review a vehicle’s safety summary",
    "category": "Fleet & assets",
    "summary": "Find a vehicle’s safety summary and expand its recorded events.",
    "feature": "driver_safety",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "review-a-trip",
      "review-notifications"
    ],
    "keywords": [
      "driver",
      "braking",
      "cornering",
      "acceleration",
      "score"
    ],
    "routes": [
      "/dashboard/driversafety"
    ]
  },
  {
    "slug": "review-logbook",
    "title": "Check a 12-week logbook",
    "category": "Fleet & assets",
    "summary": "Check reviewed-trip totals, correct a classification and understand missing trips.",
    "feature": "logbook",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "classify-trips",
      "review-a-trip",
      "generate-a-report"
    ],
    "keywords": [
      "business",
      "personal",
      "kilometres",
      "reviewed"
    ],
    "routes": [
      "/dashboard/logbook"
    ]
  },
  {
    "slug": "review-timeline",
    "title": "Review a vehicle’s activity timeline",
    "category": "Fleet & assets",
    "summary": "See ignition and movement events for a selected day.",
    "feature": "web_timeline",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "review-a-trip",
      "find-an-asset"
    ],
    "keywords": [
      "history",
      "events",
      "ignition"
    ],
    "routes": [
      "/dashboard/timeline"
    ]
  },
  {
    "slug": "create-maintenance-task",
    "title": "Create a recurring maintenance task",
    "category": "Maintenance",
    "summary": "Set a maintenance interval and choose the vehicles it applies to.",
    "feature": "vehicle_task_management",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "review-maintenance",
      "create-task-template"
    ],
    "keywords": [
      "schedule",
      "service",
      "recurring"
    ],
    "routes": [
      "/dashboard/tasks"
    ]
  },
  {
    "slug": "create-task-template",
    "title": "Create a reusable task template",
    "category": "Maintenance",
    "summary": "Save a task description and interval for future use.",
    "feature": "vehicle_task_management",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "create-maintenance-task"
    ],
    "keywords": [
      "maintenance",
      "recurring",
      "reuse"
    ],
    "routes": [
      "/dashboard/task-templates"
    ]
  },
  {
    "slug": "review-a-trip",
    "title": "Review and replay a trip",
    "category": "Fleet & assets",
    "summary": "Choose a vehicle and date, then follow a recorded journey.",
    "feature": "web_trips",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-an-asset",
      "generate-a-report"
    ],
    "keywords": [
      "journey",
      "playback",
      "history"
    ],
    "routes": [
      "/dashboard/trips"
    ]
  },
  {
    "slug": "find-a-site",
    "title": "Find a site and check its boundary",
    "category": "Sites & operations",
    "summary": "Search your geofences and inspect the saved site boundary.",
    "feature": "web_sites",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-an-asset",
      "create-geofence"
    ],
    "keywords": [
      "geofence",
      "location",
      "area"
    ],
    "routes": [
      "/dashboard/geofences"
    ]
  },
  {
    "slug": "review-maintenance",
    "title": "Check upcoming vehicle maintenance",
    "category": "Maintenance",
    "summary": "Filter the maintenance board and open a vehicle’s service schedules.",
    "feature": "vehicle_task_management",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "create-maintenance-task",
      "record-maintenance"
    ],
    "keywords": [
      "service",
      "odometer",
      "tasks",
      "due"
    ],
    "routes": [
      "/dashboard/maintenance-board"
    ]
  },
  {
    "slug": "getting-started",
    "title": "Find your way around",
    "category": "Getting started",
    "summary": "Open a feature, find help and understand your access.",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-an-asset",
      "use-fleet-dashboard"
    ],
    "aliases": [
      "overview/welcome",
      "overview/getting-started",
      "webapp/overview"
    ],
    "routes": [],
    "keywords": [
      "help centre",
      "find a feature",
      "navigation",
      "search menu"
    ]
  },
  {
    "slug": "find-an-asset",
    "title": "Find an asset on the map",
    "category": "Fleet & assets",
    "summary": "Search the device list and locate a vehicle.",
    "feature": "web_asset_map",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "use-vehicle-hub",
      "review-timeline",
      "follow-a-vehicle",
      "getting-started",
      "use-operating-view",
      "change-fleet-list"
    ],
    "routes": [
      "/dashboard/assets"
    ]
  },
  {
    "slug": "save-a-form-draft",
    "title": "Save and resume a form",
    "category": "Forms",
    "summary": "Start a form, save your progress and finish later.",
    "feature": "forms",
    "permissions": [
      "complete_forms"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "complete-a-form",
      "find-completed-form",
      "getting-started"
    ],
    "routes": [
      "/dashboard/forms/selection"
    ]
  },
  {
    "slug": "complete-a-form",
    "title": "Complete a form",
    "category": "Forms",
    "summary": "Choose a form, fill it in and submit it.",
    "feature": "forms",
    "permissions": [
      "complete_forms"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "save-a-form-draft",
      "find-completed-form"
    ],
    "routes": [
      "/dashboard/forms/selection"
    ]
  },
  {
    "slug": "generate-a-report",
    "title": "Generate a report",
    "category": "Reports & insights",
    "summary": "Choose a report and the period you need.",
    "feature": "reporting",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [],
    "aliases": [
      "reports/generate-report"
    ],
    "routes": [
      "/dashboard/reports"
    ]
  },
  {
    "slug": "use-operating-view",
    "title": "Enter and leave Operating View",
    "category": "Fleet & assets",
    "summary": "Switch machine activity on or off and return to the normal fleet view.",
    "feature": "web_asset_map",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-an-asset",
      "change-fleet-list",
      "follow-a-vehicle"
    ],
    "keywords": [
      "settings",
      "idle",
      "off",
      "moving",
      "unknown"
    ],
    "routes": [
      "/dashboard/assets"
    ]
  },
  {
    "slug": "follow-a-vehicle",
    "title": "Follow a vehicle and return to the full map",
    "category": "Fleet & assets",
    "summary": "Start and stop Follow, then show the available vehicle positions.",
    "feature": "web_asset_map",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-an-asset",
      "use-operating-view",
      "review-a-trip"
    ],
    "keywords": [
      "live",
      "tracking",
      "pan",
      "zoom"
    ],
    "routes": [
      "/dashboard/assets"
    ]
  },
  {
    "slug": "change-fleet-list",
    "title": "Change fleet card size and sorting",
    "category": "Fleet & assets",
    "summary": "Use compact vehicle cards or alphabetical order, and switch back.",
    "feature": "web_asset_map",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "find-an-asset",
      "use-operating-view"
    ],
    "keywords": [
      "settings",
      "compact",
      "list",
      "alphabetical"
    ],
    "routes": [
      "/dashboard/assets"
    ]
  },
  {
    "slug": "check-duress-monitoring",
    "title": "Check duress monitoring and sound",
    "category": "Safety & alerts",
    "summary": "Check monitoring, test browser sound and open incident history.",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "handle-duress-incident",
      "review-notifications"
    ],
    "keywords": [
      "alarm",
      "volume",
      "history",
      "audio"
    ],
    "routes": []
  },
  {
    "slug": "handle-duress-incident",
    "title": "Handle a duress incident",
    "category": "Safety & alerts",
    "summary": "Take control, review the location and resolve an incident with a note.",
    "status": "published",
    "reviewed": "2026-10-29",
    "related": [
      "check-duress-monitoring"
    ],
    "keywords": [
      "alarm",
      "response",
      "resolve",
      "release",
      "emergency"
    ],
    "routes": []
  },
  {
    "slug": "requested-forms",
    "title": "Request a form and check progress",
    "category": "Forms",
    "summary": "Request a form, complete it and check the returned answers.",
    "feature": "forms",
    "permissions": [
      "forms_view"
    ],
    "routes": [
      "/dashboard/forms/requested"
    ],
    "related": [
      "complete-a-form",
      "find-completed-form"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "requested forms",
      "form requests",
      "recipients"
    ]
  },
  {
    "slug": "pinned-forms",
    "title": "Pin and unpin a form",
    "category": "Forms",
    "summary": "Keep frequently used company forms in the pinned list.",
    "feature": "forms",
    "permissions": [
      "forms_add"
    ],
    "routes": [
      "/dashboard/forms/pinned"
    ],
    "related": [
      "create-form-template",
      "complete-a-form"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "pinned forms",
      "pin",
      "unpin"
    ]
  },
  {
    "slug": "review-form-submissions",
    "title": "Approve or decline a form submission",
    "category": "Forms",
    "summary": "Read the answers, confirm a decision and check its saved status.",
    "feature": "forms",
    "permissions": [
      "forms_edit"
    ],
    "routes": [
      "/dashboard/forms/review"
    ],
    "related": [
      "find-completed-form",
      "requested-forms"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "review forms",
      "approve",
      "decline"
    ]
  },
  {
    "slug": "asset-dashboard-forms",
    "title": "Check forms shown on asset dashboards",
    "category": "Forms",
    "summary": "Find a form and understand public, signed-in and hidden visibility.",
    "feature": "forms",
    "permissions": [
      "forms_add"
    ],
    "routes": [
      "/dashboard/dashboard-forms"
    ],
    "related": [
      "create-form-template",
      "pinned-forms"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "asset dashboard forms",
      "visibility",
      "public",
      "authenticated",
      "hidden"
    ]
  },
  {
    "slug": "required-forms",
    "title": "Find and complete required forms",
    "category": "Forms",
    "summary": "Check due work and open the required check.",
    "feature": "forms",
    "permissions": [
      "forms_view"
    ],
    "routes": [
      "/dashboard/required-forms"
    ],
    "status": "draft",
    "reviewed": "2026-10-29",
    "blocker": "Live page says Required Forms is not available for your company yet."
  },
  {
    "slug": "completed-prestarts",
    "title": "Find completed prestart checks",
    "category": "Forms",
    "summary": "Search prestart history and inspect a saved check.",
    "feature": "forms",
    "permissions": [
      "forms_view"
    ],
    "routes": [
      "/dashboard/forms/completed-prestarts"
    ],
    "status": "draft",
    "reviewed": "2026-10-29",
    "blocker": "Live route redirects to the fleet map and the menu does not expose Completed Prestarts."
  },
  {
    "slug": "driver-management",
    "title": "Find a driver and their shifts",
    "category": "Fleet & assets",
    "summary": "Check current shifts or search a driver’s history.",
    "routes": [
      "/dashboard/drivermanagement"
    ],
    "feature": "driver_management",
    "related": [
      "review-a-trip",
      "driver-tags"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "driver management",
      "drivers",
      "shifts"
    ]
  },
  {
    "slug": "driver-tags",
    "title": "Link a driver to a Bluetooth tag",
    "category": "Fleet & assets",
    "summary": "Choose the correct driver and beacon, then check the saved mapping.",
    "routes": [
      "/dashboard/driver-tags",
      "/dashboard/driver-tag"
    ],
    "feature": "driver_management",
    "related": [
      "manage-beacons",
      "driver-management"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "driver tags",
      "Bluetooth",
      "identification"
    ]
  },
  {
    "slug": "classify-trips",
    "title": "Assign business or personal use to a trip",
    "category": "Fleet & assets",
    "summary": "Review a trip’s purpose and check its saved classification.",
    "routes": [
      "/dashboard/trip-assignment"
    ],
    "feature": "logbook",
    "related": [
      "review-logbook",
      "review-a-trip"
    ],
    "keywords": [
      "assigning",
      "assignment",
      "classification",
      "business",
      "personal",
      "logbook",
      "trip assignment"
    ],
    "status": "published",
    "reviewed": "2026-10-29"
  },
  {
    "slug": "overview-map",
    "title": "Review vehicle history in Overview Map",
    "category": "Fleet & assets",
    "summary": "Choose a vehicle, use weekly or custom periods and read recorded paths.",
    "routes": [
      "/dashboard/overview-map"
    ],
    "feature": "web_overview_map",
    "related": [
      "review-a-trip",
      "find-an-asset"
    ],
    "status": "published",
    "reviewed": "2026-10-29"
  },
  {
    "slug": "coverage-analysis",
    "title": "Calculate coverage and download a report",
    "category": "Sites & operations",
    "summary": "Select paths, working width and an area, then read and export coverage.",
    "routes": [
      "/coverage-map"
    ],
    "feature": "web_coverage_analysis",
    "related": [
      "find-a-site",
      "review-inputs"
    ],
    "status": "published",
    "reviewed": "2026-10-29"
  },
  {
    "slug": "live-conditions",
    "title": "Read the Live Condition Board",
    "category": "Safety & alerts",
    "summary": "Check vehicle conditions, alert reasons and reading freshness.",
    "routes": [
      "/dashboard/compartment-monitoring"
    ],
    "feature": "web_live_conditions",
    "related": [
      "review-notifications",
      "cold-chain"
    ],
    "status": "published",
    "reviewed": "2026-10-29"
  },
  {
    "slug": "dashcam-events",
    "title": "Filter dashcam events",
    "category": "Fleet & assets",
    "summary": "Choose dates, media, cameras and event types.",
    "routes": [
      "/dashboard/dashcam-events"
    ],
    "feature": "dashcam",
    "related": [
      "review-driver-safety",
      "review-notifications"
    ],
    "status": "published",
    "reviewed": "2026-10-29"
  },
  {
    "slug": "cold-chain",
    "title": "Find an asset on the Cold Chain dashboard",
    "category": "Safety & alerts",
    "summary": "Check listed sensors and find the graph and notification views.",
    "routes": [
      "/dashboard/environment"
    ],
    "feature": "cold_chain",
    "related": [
      "live-conditions",
      "review-notifications"
    ],
    "status": "published",
    "reviewed": "2026-10-29"
  },
  {
    "slug": "manage-beacons",
    "title": "Add a beacon and check its details",
    "category": "Fleet & assets",
    "summary": "Register a beacon, apply a configuration and check its saved assignment.",
    "routes": [
      "/dashboard/beacons",
      "/dashboard/beacon"
    ],
    "feature": "ble_beacons",
    "related": [
      "beacon-types",
      "driver-tags",
      "beacon-overview-map"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "beacons",
      "UUID",
      "nickname"
    ]
  },
  {
    "slug": "beacon-types",
    "title": "Create a beacon type with existing fields",
    "category": "Fleet & assets",
    "summary": "Create a configuration with existing fields and apply it to a beacon.",
    "routes": [
      "/dashboard/beacon-config"
    ],
    "feature": "ble_beacons",
    "related": [
      "manage-beacons"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "beacon types",
      "beacon config",
      "custom fields"
    ]
  },
  {
    "slug": "beacon-overview-map",
    "title": "Open the Beacon Overview Map",
    "category": "Fleet & assets",
    "summary": "Choose a vehicle to inspect its beacon overview.",
    "routes": [
      "/dashboard/beacon-overview-map"
    ],
    "feature": "web_beacon_overview_map",
    "related": [
      "manage-beacons",
      "overview-map"
    ],
    "status": "published",
    "reviewed": "2026-10-29"
  },
  {
    "slug": "insight-tags",
    "title": "Create an Insight Tag and its document",
    "category": "Sites & operations",
    "summary": "Create and edit a text document, then verify its public QR experience.",
    "routes": [
      "/dashboard/insight-tags",
      "/dashboard/insight-tag"
    ],
    "feature": "insight_tags",
    "related": [
      "getting-started"
    ],
    "status": "published",
    "reviewed": "2026-10-29"
  },
  {
    "slug": "manage-people",
    "title": "Find a person and correct their details",
    "category": "Administration",
    "summary": "Find the right person, save a basic detail and verify it after reopening.",
    "routes": [
      "/dashboard/admin/people"
    ],
    "related": [
      "manage-groups",
      "device-linking",
      "my-account"
    ],
    "permissions": [
      "people_view"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "people",
      "person",
      "profile"
    ]
  },
  {
    "slug": "manage-groups",
    "title": "Create a group and manage its vehicles",
    "category": "Administration",
    "summary": "Create or rename a group, assign a vehicle and check the saved membership.",
    "routes": [
      "/dashboard/admin/groups"
    ],
    "related": [
      "manage-people",
      "manage-jobsites"
    ],
    "permissions": [
      "groups_view"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "groups",
      "assigned",
      "unassigned"
    ]
  },
  {
    "slug": "manage-jobsites",
    "title": "Create a jobsite and update its details",
    "category": "Administration",
    "summary": "Find or create a jobsite, correct a detail and check the saved result.",
    "routes": [
      "/dashboard/admin/jobsites",
      "/dashboard/admin/jobsite"
    ],
    "related": [
      "find-a-site",
      "manage-groups"
    ],
    "permissions": [
      "jobsites_view"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "jobsites",
      "jobsite",
      "completed jobs"
    ]
  },
  {
    "slug": "company-settings",
    "title": "Update basic company details",
    "category": "Administration",
    "summary": "Save General details, check the result and locate other company settings.",
    "routes": [
      "/dashboard/company_settings"
    ],
    "related": [
      "driver-tags",
      "asset-dashboard-forms",
      "check-duress-monitoring"
    ],
    "permissions": [
      "edit_permissions"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "company settings",
      "hardware",
      "logo"
    ]
  },
  {
    "slug": "device-linking",
    "title": "Check which devices are linked to an account",
    "category": "Administration",
    "summary": "Select a user and review their existing vehicle links.",
    "routes": [
      "/dashboard/admin/accdevlink"
    ],
    "related": [
      "manage-people",
      "driver-tags"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "account device linking",
      "account / device linking",
      "access"
    ]
  },
  {
    "slug": "my-account",
    "title": "Update your account details",
    "category": "Administration",
    "summary": "Save a profile correction, check it and reset unsaved edits.",
    "routes": [
      "/dashboard/account"
    ],
    "related": [
      "getting-started"
    ],
    "status": "published",
    "reviewed": "2026-10-29",
    "keywords": [
      "my account",
      "profile",
      "reset",
      "personal details"
    ]
  }
];
export const articlePath = (article) => `/docs/${article.slug}`;
export const findArticle = (slug) =>
  articles.find((a) => a.slug === slug || (a.aliases || []).includes(slug));
export function canReadArticle(article, user) {
  if (!article || !user || article.status !== "published") return false;
  if (
    user.tsadmin &&
    !["getting-started", "find-an-asset"].includes(article.slug)
  )
    return false;
  return (
    isCompanyFeatureEnabled(user.features_enabled, article.feature) &&
    (article.permissions || []).every((key) =>
      Boolean(user.permissions?.[key])
    ) &&
    (!article.vehicleAssignment || canAccessVehicleAssignment(user.companyid))
  );
}
export function searchArticles(user, query = "", category = "") {
  const words = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
  return articles.filter(
    (a) =>
      canReadArticle(a, user) &&
      (!category || a.category === category) &&
      words.every((word) =>
        `${a.title} ${a.summary} ${a.category} ${(a.keywords || []).join(" ")}`
          .toLowerCase()
          .includes(word)
      )
  );
}
export function contextualArticle(user, pathname) {
  return articles.find(
    (a) =>
      canReadArticle(a, user) &&
      (a.routes || []).some(
        (route) => pathname === route || pathname.startsWith(`${route}/`)
      )
  );
}
